import { createApiSlice } from "@common/common-slice/commonSlice";

import { CRUD_PROGRAMMING_LANGUGAGE, GET_DETAILS_PROGRAMMING_LANGUAGE } from "@routes";

const apiConfig = [
  {
    name: "addProgrammingLanguage",
    method: "post",
    url: CRUD_PROGRAMMING_LANGUGAGE,
    stateKey: "message",
  },
  {
    name: "updateProgrammingLanguage",
    method: "put",
    url: CRUD_PROGRAMMING_LANGUGAGE,
    stateKey: "message",
  },
  {
    name: "deleteProgrammingLanguage",
    method: "delete",
    url: CRUD_PROGRAMMING_LANGUGAGE,
    stateKey: "message",
  },
  {
    name: "getProgrammingLanguage",
    method: "get",
    url: CRUD_PROGRAMMING_LANGUGAGE,
    stateKey: "data",
  },
  {
    name: "getProgrammingLanguageDetails",
    method: "get",
    url: GET_DETAILS_PROGRAMMING_LANGUAGE,
    stateKey: "detailsData",
  },
];

const customReducers = {
  initialState: {
    additionalData: [],
    details: [],
    detailsData: [],
    selectedData: {},
  },
  reducers: {
    rowSelect: (state, action) => {
      state.selectedData =
        action?.payload?.length > 0 ? action.payload[0] : {};
    },
  },
};

const { slice, thunks, actions } = createApiSlice(
  "programmingLanguage",
  apiConfig,
  customReducers
);

const programmingLanguageSlice = slice;

export default programmingLanguageSlice.reducer;

export const actionsExports = actions;

export const {
  getProgrammingLanguage,
  getProgrammingLanguageDetails,
  addProgrammingLanguage,
  updateProgrammingLanguage,
  deleteProgrammingLanguage,
} = thunks;

export const {
  rowSelect,
} = actionsExports;
